export const tableOption = function () {
    return {
        add: '新增',
        edit: '修改',
        view: '查看',
        page: true,
        selection: false,
        index: false,
        indexLabel: '序号',
        refreshBtn: false,
        columnBtn: false,
        stripe: true,
        addBtn: false,
        editBtn: false,
        delBtn: false,
        viewFormSlot: true,
        labelSuffix: '：',
        align: 'left',
        size: 'small',
        maxHeight: '100%',
        labelWidth: '100px',
        labelPosition: 'right',
        menuWidth: 200,
        menuAlign: "center",
        searchMenuSpan: 6,
        searchBtn: false,
        dialogHeight: 350,
        dialogWidth: '640px',
        emptyText: '暂无数据',
        menu: false,
        column: [{
            label: '回路名称',
            prop: 'name',
            search: false,
            addDisplay: false,
            editDisplay: false,
            viewDisplay: true,
            editDisabled: false,
            overHidden: true,
            align: 'center',
            columnWidth: '260'
        },
        {
            label: '0时',
            prop: '00',
            search: false,
            searchSlot: false,
            addDisplay: false,
            editDisplay: false,
            viewDisplay: true,
            editDisabled: false,
            overHidden: true,
            align: 'center'
        },
        {
            label: '1时',
            prop: '01',
            search: false,
            searchSlot: false,
            addDisplay: false,
            editDisplay: false,
            viewDisplay: true,
            editDisabled: false,
            overHidden: true,
            align: 'center'
        },
        {
            label: '2时',
            prop: '02',
            search: false,
            searchSlot: false,
            addDisplay: false,
            editDisplay: false,
            viewDisplay: true,
            editDisabled: false,
            overHidden: true,
            align: 'center'
        },
        {
            label: '3时',
            prop: '03',
            search: false,
            searchSlot: false,
            addDisplay: false,
            editDisplay: false,
            viewDisplay: true,
            editDisabled: false,
            overHidden: true,
            align: 'center'
        },
        {
            label: '4时',
            prop: '04',
            search: false,
            searchSlot: false,
            addDisplay: false,
            editDisplay: false,
            viewDisplay: true,
            editDisabled: false,
            overHidden: true,
            align: 'center'
        },
        {
            label: '5时',
            prop: '05',
            search: false,
            searchSlot: false,
            addDisplay: false,
            editDisplay: false,
            viewDisplay: true,
            editDisabled: false,
            overHidden: true,
            align: 'center'
        },
        {
            label: '6时',
            prop: '06',
            search: false,
            searchSlot: false,
            addDisplay: false,
            editDisplay: false,
            viewDisplay: true,
            editDisabled: false,
            overHidden: true,
            align: 'center'
        },
        {
            label: '7时',
            prop: '07',
            search: false,
            searchSlot: false,
            addDisplay: false,
            editDisplay: false,
            viewDisplay: true,
            editDisabled: false,
            overHidden: true,
            align: 'center'
        },
        {
            label: '8时',
            prop: '08',
            search: false,
            searchSlot: false,
            addDisplay: false,
            editDisplay: false,
            viewDisplay: true,
            editDisabled: false,
            overHidden: true,
            align: 'center'
        },
        {
            label: '9时',
            prop: '09',
            search: false,
            searchSlot: false,
            addDisplay: false,
            editDisplay: false,
            viewDisplay: true,
            editDisabled: false,
            overHidden: true,
            align: 'center'
        },
        {
            label: '10时',
            prop: '10',
            search: false,
            searchSlot: false,
            addDisplay: false,
            editDisplay: false,
            viewDisplay: true,
            editDisabled: false,
            overHidden: true,
            align: 'center'
        },
        {
            label: '11时',
            prop: '11',
            search: false,
            searchSlot: false,
            addDisplay: false,
            editDisplay: false,
            viewDisplay: true,
            editDisabled: false,
            overHidden: true,
            align: 'center'
        },
        {
            label: '12时',
            prop: '12',
            search: false,
            searchSlot: false,
            addDisplay: false,
            editDisplay: false,
            viewDisplay: true,
            editDisabled: false,
            overHidden: true,
            align: 'center'
        },
        {
            label: '13时',
            prop: '13',
            search: false,
            searchSlot: false,
            addDisplay: false,
            editDisplay: false,
            viewDisplay: true,
            editDisabled: false,
            overHidden: true,
            align: 'center'
        },
        {
            label: '14时',
            prop: '14',
            search: false,
            searchSlot: false,
            addDisplay: false,
            editDisplay: false,
            viewDisplay: true,
            editDisabled: false,
            overHidden: true,
            align: 'center'
        },
        {
            label: '15时',
            prop: '15',
            search: false,
            searchSlot: false,
            addDisplay: false,
            editDisplay: false,
            viewDisplay: true,
            editDisabled: false,
            overHidden: true,
            align: 'center'
        },
        {
            label: '16时',
            prop: '16',
            search: false,
            searchSlot: false,
            addDisplay: false,
            editDisplay: false,
            viewDisplay: true,
            editDisabled: false,
            overHidden: true,
            align: 'center'
        },
        {
            label: '17时',
            prop: '17',
            search: false,
            searchSlot: false,
            addDisplay: false,
            editDisplay: false,
            viewDisplay: true,
            editDisabled: false,
            overHidden: true,
            align: 'center'
        },
        {
            label: '18时',
            prop: '18',
            search: false,
            searchSlot: false,
            addDisplay: false,
            editDisplay: false,
            viewDisplay: true,
            editDisabled: false,
            overHidden: true,
            align: 'center'
        },
        {
            label: '19时',
            prop: '19',
            search: false,
            searchSlot: false,
            addDisplay: false,
            editDisplay: false,
            viewDisplay: true,
            editDisabled: false,
            overHidden: true,
            align: 'center'
        },
        {
            label: '20时',
            prop: '20',
            search: false,
            searchSlot: false,
            addDisplay: false,
            editDisplay: false,
            viewDisplay: true,
            editDisabled: false,
            overHidden: true,
            align: 'center'
        },
        {
            label: '21时',
            prop: '21',
            search: false,
            searchSlot: false,
            addDisplay: false,
            editDisplay: false,
            viewDisplay: true,
            editDisabled: false,
            overHidden: true,
            align: 'center'
        },
        {
            label: '22时',
            prop: '22',
            search: false,
            searchSlot: false,
            addDisplay: false,
            editDisplay: false,
            viewDisplay: true,
            editDisabled: false,
            overHidden: true,
            align: 'center'
        },
        {
            label: '23时',
            prop: '23',
            search: false,
            searchSlot: false,
            addDisplay: false,
            editDisplay: false,
            viewDisplay: true,
            editDisabled: false,
            overHidden: true,
            align: 'center'
        },
        ]
    }
}
